import { render, staticRenderFns } from "./OperaReductionActionWindow.vue?vue&type=template&id=3a7b1efb&scoped=true&"
import script from "./OperaReductionActionWindow.vue?vue&type=script&lang=js&"
export * from "./OperaReductionActionWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaReductionActionWindow.vue?vue&type=style&index=0&id=3a7b1efb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7b1efb",
  null
  
)

export default component.exports